import { render, staticRenderFns } from "./landing.vue?vue&type=template&id=1ff1a1ee"
import script from "./landing.vue?vue&type=script&lang=js"
export * from "./landing.vue?vue&type=script&lang=js"
import style0 from "./landing.vue?vue&type=style&index=0&id=1ff1a1ee&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports